import { createI18n, I18nOptions } from 'vue-i18n';

import en from './locales/en.json';
import uk from './locales/uk.json';

const options: I18nOptions = {
  legacy: false,
  messages: { en, uk },
  warnHtmlMessage: false,
  locale: 'en',
  fallbackLocale: 'en',
  globalInjection: true,
};

export const i18n = createI18n(options);

export const createI18nFn = () => {
  return createI18n(options);
};
